export const DASHBOARD_UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const getDashboardSearchContext = (searchTerm = "") => {
  const search = String(searchTerm || "").trim();
  const isUUID = DASHBOARD_UUID_REGEX.test(search);

  return {
    search,
    isUUID,
    isTextSearch: Boolean(search && !isUUID),
  };
};

export const normalizeDashboardPhoneSearchValue = (value = "") =>
  String(value || "").replace(/\D/g, "");

export const createDashboardSearchResolution = ({
  status = "not_applicable",
  matchedUserIds = null,
  source = "none",
  errorMessage = null,
} = {}) => ({
  status,
  matchedUserIds,
  source,
  errorMessage,
});

export const getDashboardUsersSelect = ({
  searchContext,
  searchResolution,
  minimal = false,
}) => {
  const fields = minimal
    ? `
          id,
          name,
          phone
        `
    : `
          id,
          name,
          phone,
          session_id,
          is_anonymous,
          created_at,
          updated_at
        `;

  const useInnerJoin =
    searchContext?.isTextSearch &&
    !Array.isArray(searchResolution?.matchedUserIds) &&
    searchResolution?.status !== "unavailable";

  return useInnerJoin ? `users!inner (${fields})` : `users (${fields})`;
};

export const getDashboardSearchFilterState = ({
  searchContext,
  searchResolution,
}) => {
  if (!searchContext?.isTextSearch) {
    return {
      mode: searchContext?.isUUID ? "uuid" : "none",
      matchedUserIds: null,
      isResolvedEmpty: false,
      shouldAbort: false,
      errorMessage: null,
    };
  }

  if (searchResolution?.status === "unavailable") {
    return {
      mode: "unavailable",
      matchedUserIds: null,
      isResolvedEmpty: false,
      shouldAbort: true,
      errorMessage:
        searchResolution.errorMessage ||
        "Phone search is temporarily unavailable. Please try again later.",
    };
  }

  if (Array.isArray(searchResolution?.matchedUserIds)) {
    return {
      mode: "resolved_ids",
      matchedUserIds: searchResolution.matchedUserIds,
      isResolvedEmpty: searchResolution.matchedUserIds.length === 0,
      shouldAbort: false,
      errorMessage: null,
    };
  }

  return {
    mode: "direct_phone_filter",
    matchedUserIds: null,
    isResolvedEmpty: false,
    shouldAbort: false,
    errorMessage: null,
  };
};

export const buildDashboardSearchUnavailableError = (searchResolution) =>
  new Error(
    searchResolution?.errorMessage ||
      "Phone search is temporarily unavailable. Please try again later."
  );
